import React, { useState } from 'react';
import { Page, Document, pdfjs} from 'react-pdf';
import { makeStyles} from '@material-ui/core';
import Button from '@mui/material/Button';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';

const workerSrcUrl = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
pdfjs.GlobalWorkerOptions.workerSrc = workerSrcUrl ;

const useStyles = makeStyles(theme => ({
  nav:{
    position: 'absolute',
    top: '0',
    paddingBottom:'1%',
    zIndex: '4',
    width: '100%',
    display: 'inline-block',
    alignItems: 'center',
    background:'#fff',
    textAlign: 'center',
    fontSize: '1.2em'
  },
  pageCount:{
    marginRight: '5px',
    marginLeft: '5px',
  },
  pageCountNum:{
    marginRight: '10px',
    marginLeft: '10px',
  },
  zoomIn:{
    position: 'absolute',
    right: '-28%',
  },
  zoomOut:{
    position: 'absolute',
    right: '-30%',
  },
  rotateLeft:{
    position: 'absolute',
    right: '5%',
  },
  rotateRight:{
    position: 'absolute',
    right: '6%',
  },
  backAttaches:{
    position: 'absolute',
    left: '-14%',
    top: '0',
    zIndex: '5',
  },
  pdfContainer:{
    display: 'flex',
    flexFlow: 'column nowrap',
    alignContent: 'center',
    background: '#d1d7e0',
    color: '#FFFFFF',
    fontSize: '3em',
    padding: '10px',
    width: '100%',
    height: '65vh',
    marginTop: '2%',
    marginBottom: '2%',
    overflow: 'auto',
  },
  pdfWrap:{
   margin: '5px auto',
   marginTop: '30px',
   flex: '1 1 auto',
   zIndex:'2',
  },
  loading:{
    position:'absolute',
    top: '50%',
    fontSize: '1000px',
  },
  pdfPage:{
    
  },

}));

  const PdfViewerTool = ({filePdf, handleCloseViewer})=>{
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.38);
  const [rotate, setRotate] = useState(0);

  

  const classes = useStyles();
  
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const showNext=()=>{
  if(pageNumber<numPages)
  {    
  setPageNumber(pageNumber+1);
  }
  else
  {
      setPageNumber(pageNumber);
  }
  }

  const showPrev=()=>{
    if(pageNumber>1)
    {    
    setPageNumber(pageNumber-1);
    }
    else
    {
        setPageNumber(pageNumber);
    }
    }
    const closeViewer=()=>{
      handleCloseViewer()
    }
    
    const zoomIn = ()=>{
      if(scale >= 3.5){console.log('mucho zoom out !!')}
      else{
        const newZoom = scale + 0.2;
        setScale(newZoom);
        console.log(scale)
      }
    }
    const zoomOut = ()=>{
      if(scale <= 0.52){console.log('mucho zoom out !!')}
      else{
        const newZoom = scale - 0.2;
        setScale(newZoom);
        console.log(scale)
      }
    }
    const rotateToLeft = ()=>{
      const left = rotate - 90;
      setRotate(left)
    }
    const rotateToRight = ()=>{
      const right = rotate + 90;
      setRotate(right)
    }

  return (
    <div>
      <nav className={classes.nav}>
        <Button 
          variant="contained" 
          size='samll' 
          className={classes.backAttaches} 
          onClick={closeViewer}>
          Volver
          <i className="fas fa-arrow-left"/>
          </Button>
        <Button variant="outlined" onClick={showPrev} >
            <ArrowLeftIcon/>
        </Button>
            <label className={classes.pageCount}>Page  </label>
            <span className={classes.pageCountNum} id='page-no'>{pageNumber}</span>
            <label className={classes.pageCount}>  Of  </label>
            <span className={classes.pageCountNum} id='page-count'>{numPages}</span>
        <Button variant="outlined" onClick={showNext} >
            <ArrowRightIcon/>
        </Button>
        <Button className={classes.zoomIn} onClick={zoomIn}>
            <ZoomInIcon/>
        </Button>
        <Button className={classes.zoomOut} onClick={zoomOut}>
            <ZoomOutIcon/>
        </Button>
        <Button className={classes.rotateLeft} onClick={rotateToLeft}>
            <RotateLeftIcon/>
        </Button>
        <Button className={classes.rotateRight} onClick={rotateToRight}>
            <RotateRightIcon/>
        </Button>
      </nav>
      <div className={classes.pdfContainer}>
        <div className={classes.pdfWrap}>
          <Document 
              className={classes.pdfDocument}
              file={filePdf}
              onLoadSuccess={onDocumentLoadSuccess}
              loading={
                <Box sx={{ display: 'flex' }}>
                  <CircularProgress className={classes.loading} size={80}/>
                </Box>
              }
              error={
                <Stack sx={{ width: '100%' }} spacing={2}>
                  <Alert severity="error">No se encuentra archivo PDF</Alert>
                </Stack>
              }
              onLoadError={
                <Stack sx={{ width: '100%' }} spacing={2}>
                  <Alert severity="error">error al cargar archivo PDF</Alert>
                </Stack> 
              }
              noData={
                <Stack sx={{ width: '100%' }} spacing={2}>
                  <Alert severity="warning">No se ha seleccionado ningun archivo PDF</Alert>
                </Stack> 
              }
              >
              <Page 
              className={classes.pdfPage}
              pageNumber={pageNumber} 
              scale={scale}
              rotate={rotate}
              />
            </Document>
        </div>    
      </div>
    </div>
  );
}
export default PdfViewerTool